/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

import { isTesting } from '@embroider/macros';

// When under test we will use UTC to make it easier to have consistent assertions
const defaultTimeZone = isTesting()
  ? 'Etc/UTC'
  : Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatDateTime = (
  date: Date,
  timeZone = defaultTimeZone,
): string => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
    timeZone,
  }).format(date);
};

export const daysToGrpcDuration = (days: number) => {
  const hours = days * 24;
  return `${hours}h`;
};

const dateTimeUtils = {
  formatDateTime,
  daysToGrpcDuration,
};

export default dateTimeUtils;
